import { AddressApiModel } from './../../../components/map/map.models';
import { createAction, props } from '@ngrx/store';
import { MwPayloadModel } from 'app/models/payload.model';
import { MwLoadOptions } from 'app/models/load-options.model';

export const loadAddresses = createAction(
  '[Addresses] Load',
  props<{ loadOptions: MwLoadOptions }>()
);

export const loadAddressesSuccess = createAction(
  '[Addresses] Load Successful',
  props<{ response: MwPayloadModel<AddressApiModel[]> }>()
);

export const loadAddressesFailed = createAction(
  '[Addresses] Load Failed',
  props<{ error: any }>()
);

export const createAddress = createAction(
  '[Address] Create',
  props<{ address: AddressApiModel }>()
);

export const createAddressSuccess = createAction(
  '[Address] Create Successful',
  props<{ address: AddressApiModel }>()
);

export const createAddressFailed = createAction(
  '[Address] Create Failure',
  props<{ error: any }>()
);

export const updateAddress = createAction(
  '[Address] Update',
  props<{ address: AddressApiModel }>()
);

export const updateAddressSuccess = createAction(
  '[Address] Update Successful',
  props<{ address: AddressApiModel }>()
);

export const updateAddressFailed = createAction(
  '[Address] Update Failure',
  props<{ error: any }>()
);

export const deleteAddress = createAction(
  '[Address] Delete',
  props<{ address: AddressApiModel }>()
);

export const deleteAddressSuccess = createAction('[Address] Delete Successful');

export const deleteAddressFailed = createAction(
  '[Address] Delete Failure',
  props<{ error: any }>()
);

export const loadAddress = createAction(
  '[Address] Load',
  props<{ addressId: number }>()
);

export const loadAddressSuccess = createAction(
  '[Address] Load Successful',
  props<{ address: AddressApiModel }>()
);

export const loadAddressFailed = createAction(
  '[Address] Load Failure',
  props<{ error: any }>()
);

export const resetAddress = createAction('[Address] Reset');
